import {
	GET_CATEGORY_DETAIL_REQUEST,
	GET_CATEGORY_DETAIL_SUCCESS,
	GET_CATEGORY_DETAIL_ERROR,
	GET_ALL_CATEGORY_REQUEST,
	GET_ALL_CATEGORY_SUCCESS,
	GET_ALL_CATEGORY_ERROR,
	GET_CUSTOM_CATEGORY_DETAIL_REQUEST,
	GET_CUSTOM_CATEGORY_DETAIL_SUCCESS,
	GET_CUSTOM_CATEGORY_DETAIL_FAILED,
	GET_CATEGORY_DETAIL_UNCHANGED,
	GET_ALL_CATEGORY_UNCHANGED,
	GET_CUSTOM_CATEGORY_DETAIL_UNCHANGED,
} from "../actions/categoryActions";
import { CONTENT_SCOPE_CHANGED } from "../actions/contentCacheActions";

const initialState = {
	contentUserScope: null,
	loading: false,
	refreshing: false,
	currentCategoryRequestKey: null,
	categoryViewDetails: {},
	load: false, //used for all category load request
	allCategoriesRefreshing: false,
	allCategoryData: [], //all category data.
	custom_category_loader:false,
	customCategoryRefreshing:false,
	currentCustomCategoryRequestKey:null,
	custom_category_data:{},
};

export const CategoryReducer = (state = initialState, action) => {
	switch (action.type) {
		case CONTENT_SCOPE_CHANGED:
			return { ...initialState, contentUserScope: action.userScope };
		case GET_CATEGORY_DETAIL_REQUEST:
			{
			const hasMatchingData = state.currentCategoryRequestKey === action.requestKey
				&& Boolean(state.categoryViewDetails?.id);
			return {
				...state,
				loading: !hasMatchingData,
				refreshing: hasMatchingData,
				currentCategoryRequestKey: action.requestKey,
			};
			}
		case GET_CATEGORY_DETAIL_SUCCESS:
			if (state.contentUserScope && action.userScope && state.contentUserScope !== action.userScope) {
				return state;
			}
			if (state.currentCategoryRequestKey && action.requestKey !== state.currentCategoryRequestKey) {
				return state;
			}
			return {
				...state,
				loading: false,
				refreshing: action?.source === "cache",
				categoryViewDetails: action?.payload,
			};
		case GET_CATEGORY_DETAIL_UNCHANGED:
			if (state.currentCategoryRequestKey && action.requestKey !== state.currentCategoryRequestKey) {
				return state;
			}
			return { ...state, loading: false, refreshing: false };
		case GET_CATEGORY_DETAIL_ERROR:
			if (state.currentCategoryRequestKey && action.requestKey !== state.currentCategoryRequestKey) {
				return state;
			}
			return {
				...state,
				loading: false,
				refreshing: false,
			};
		case GET_ALL_CATEGORY_REQUEST:
			return {
				...state,
				allCategoriesRefreshing: state.load,
			};
		case GET_ALL_CATEGORY_SUCCESS:
			if (state.contentUserScope && action.userScope && state.contentUserScope !== action.userScope) {
				return state;
			}
			return {
				...state,
				load: true,
				allCategoriesRefreshing: action?.source === "cache",
				allCategoryData: action?.payload,
			};
		case GET_ALL_CATEGORY_UNCHANGED:
			return { ...state, load: true, allCategoriesRefreshing: false };
		case GET_ALL_CATEGORY_ERROR:
			return {
				...state,
				allCategoriesRefreshing: false,
			};
		case GET_CUSTOM_CATEGORY_DETAIL_REQUEST:
			{
			const hasMatchingData = state.currentCustomCategoryRequestKey === action.requestKey
				&& Boolean(state.custom_category_data?.id);
			return {
				...state,
				custom_category_loader: !hasMatchingData,
				customCategoryRefreshing: hasMatchingData,
				currentCustomCategoryRequestKey: action.requestKey,
			};
			}
		case GET_CUSTOM_CATEGORY_DETAIL_SUCCESS:
			if (state.contentUserScope && action.userScope && state.contentUserScope !== action.userScope) {
				return state;
			}
			if (state.currentCustomCategoryRequestKey && action.requestKey !== state.currentCustomCategoryRequestKey) {
				return state;
			}
			return {
				...state,
				custom_category_loader: false,
				customCategoryRefreshing: action?.source === "cache",
				custom_category_data: action?.payload,
			};
		case GET_CUSTOM_CATEGORY_DETAIL_UNCHANGED:
			if (state.currentCustomCategoryRequestKey && action.requestKey !== state.currentCustomCategoryRequestKey) {
				return state;
			}
			return { ...state, custom_category_loader: false, customCategoryRefreshing: false };
		case GET_CUSTOM_CATEGORY_DETAIL_FAILED:
			if (state.currentCustomCategoryRequestKey && action.requestKey !== state.currentCustomCategoryRequestKey) {
				return state;
			}
			return {
				...state,
				custom_category_loader: false,
				customCategoryRefreshing: false,
				custom_category_data: action?.hadCachedData ? state.custom_category_data : {},
			};
		default:
			return state;
	}
};
